//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { isEmpty } from "lodash";
import MaterialInput from "./material-input.vue";
import { BIconEyeFill } from "bootstrap-vue";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "PasswordInput",
  components: {
    MaterialInput,
    BIconEyeFill
  },
  props: {
    password: {
      type: String,
      default: ""
    },
    validatorContext: {
      type: null,
      required: true
    },
    onType: {
      type: Boolean,
      default: false
    },
    clientLogin: {
      type: Boolean,
      default: false
    },
    signupClient: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showingPassword: false
    };
  },
  computed: {
    passwordModel: {
      get() {
        return this.password;
      },
      set(value) {
        if (!isEmpty(this.validatorContext)) this.validatorContext.$touch();
        this.$emit("update:password", value);
      }
    }
  },
  methods: {
    toggleShowingPassword() {
      this.showingPassword = !this.showingPassword;
    },
    handleBlur() {
      this.$emit("blur");
    }
  }
});